import * as __SNOWPACK_ENV__ from '../../_snowpack/env.js';

import axios from '../../_snowpack/pkg/axios.js';
import { toJS } from '../../_snowpack/pkg/mobx.js';
import buildQuery from '../../_snowpack/pkg/odata-query.js';
import { ApiException } from '../utils/exceptions.js';
import FilterBuilder from '../utils/filterBuilder.js';
import { toPagination } from '../utils/utils.js';
const useDirectApi = false; //__SNOWPACK_ENV__.mode === 'development';
console.log('SNOWPACK_PUBLIC_API_URL', __SNOWPACK_ENV__.SNOWPACK_PUBLIC_API_URL);
const apiUrl = useDirectApi ? 'https://localhost:44333' : __SNOWPACK_ENV__.SNOWPACK_PUBLIC_API_URL || 'https://localhost:7137/ThermalStep';
const client = axios.create({
  baseURL: apiUrl,
  headers: {
    Accept: 'application/json;odata.metadata=none',
    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token') ?? '{}').jwt}`
  }
  //timeout: 60000,
});
client.interceptors.response.use(res => {
  let data = res.data;
  if (data.status && (data.status < 200 || data.status > 299)) {
    return Promise.reject(new ApiException(data));
  }
  return res;
}, error => {
  return Promise.reject(new ApiException(error));
});
const responseBody = res => res.data;
const http = {
  get: (url, config) => client.get(url, config).then(responseBody),
  post: (url, data, config) => client.post(url, data, config).then(responseBody),
  put: (url, data, config) => client.put(url, data, config).then(responseBody),
  delete: (url, config) => client.delete(url, config).then(responseBody)
};
const getResource = resource => {
  if (useDirectApi) {
    switch (resource) {
      case 'getOrders':
        return '/odata/order';
      case 'getOrder':
        return '/orders';
      case 'updateOrder':
        return '/orders';
      case 'getTags':
        return '/tags';
      default:
        return '';
    }
  }
  return resource;
};
const pageSize = 25;
const buildFilter = params => {
  if (!!params.orderNumber) {
    return {
      orderNumber: params.orderNumber
    };
  }
  return new FilterBuilder().dateRange('orderDate', params.orderDateStart, params.orderDateEnd).dateRange('shipByDate', params.shipByDateStart, params.shipByDateEnd).condition(!!params.account, {
    account: params.account
  }).condition(!!params.status, {
    status: params.status
  }).condition(!!params.deliveryMethod, {
    deliveryMethod: params.deliveryMethod
  }).condition(!!params.trackingNumber, {
    trackingNumber: params.trackingNumber
  }).condition(!!params.tags && params.tags.length > 0, {
    tags: {
      any: {
        id: {
          in: toJS(params.tags)
        }
      }
    }
  }).value();
};
const api = {
  getOrders: params => {
    let query = buildQuery({
      filter: buildFilter(params),
      skip: pageSize * (params.page - 1),
      top: pageSize,
      orderBy: `${params.sort} ${params.order}`,
      expand: ['orderNotes', 'tags'],
      count: true
    });
    return http.get(`${getResource('getOrders')}${query}`).then(res => toPagination(res, params.page, pageSize));
  },
  getOrder: id => {
    return http.get(`${getResource('getOrder')}/${id}`);
  },
  updateOrder: data => {
    return http.put(`${getResource('updateOrder')}/${data.id}`, data);
  },
  getTags: () => {
    return http.get(`${getResource('getTags')}`);
  }
};
export default api;